<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading variant="dark" />
    </div>
    <div v-else>
      <div class="profile-container shadow-sm">
        <ProfileComponent
          :profile="profile"
          :userProfile="lineProfile"
          @logout="logout"
          :marketPlaceObj="marketPlaceObject"
          :memberLevel="memberLevel"
        />

        <MemberCard
          v-if="
            $store.state.theme.line_display_member_level == '1' &&
            lineLayout == 'Card'
          "
          :profile="profile"
          :memberLevel="memberLevel"
        />

        <UpcomingReward v-if="displayUpcomming" />
        <MarketPlaceBanner
          :marketPlaceObj="marketPlaceObject"
          v-if="$config.display_highlight_connect_channel == 1"
        />
        <Mission v-if="displayMission" />
        <CardConnectChannel
          :marketPlaceObj="marketPlaceObject"
          v-if="
            $store.state.theme.display_connect_channel == '1' &&
            lineLayout == 'Card'
          "
        />
      </div>

      <div class="m-3 shadow-sm" v-if="bannerFriend.length > 0">
        <v-carousel
          fade
          height="auto"
          :show-arrows="false"
          cycle
          autoplay="false"
          touch
          class="banner-friend"
          :hide-delimiters="bannerFriend.length == 1"
        >
          <v-carousel-item
            v-for="item in bannerFriend"
            :key="item.id"
            class="pointer"
          >
            <img
              class="d-block img-fluid w-100"
              :src="item.banner"
              alt="image slot"
              v-on:click="$router.push(`/invite/${item.id}?tabIndex=1`)"
            />
          </v-carousel-item>
        </v-carousel>
      </div>
      <div class="my-2">
        <div class="mx-3">
          <v-slide-group :show-arrows="false" center-active>
            <v-slide-group-item v-for="b in customLink" :key="b.name">
              <v-btn
                icon
                size="62"
                class="brand-btn"
                variant="plain"
                @click="openLink(getLinkDetail(b).url)"
              >
                <c-img
                  :src="getLinkDetail(b).image_url"
                  class="new-custom-link-image"
                ></c-img>
                <!-- {{ getLinkDetail(b) }} -->
              </v-btn>
            </v-slide-group-item>
          </v-slide-group>
          <!-- <template v-for="link of "> {{ link }}</template> -->
        </div>
        <!-- <div v-for="link of customLink"></div> -->
        <div class="menulist-container shadow-sm">
          <BannerProfilePanel
            v-if="bannerList.length > 0"
            :bannerList="bannerList"
            :profile="profile"
            class="p-2"
          />
          <MenuListComponentOld :MenuList="MenuList" :profile="profile" />
        </div>
      </div>
    </div>
    <ModalLoading ref="modalLoading" />
    <ModalConfirm
      ref="ModalConfirm"
      :text="$t('confirm_logout')"
      @handler="unpairfunc"
    />
  </div>
</template>

<script>
import ProfileComponent from "@/components/profile/ProfileComponent";
import MarketPlaceBanner from "@/components/profile/MarketPlaceBanner";
import BannerProfilePanel from "@/components/profile/BannerProfilePanel";
import MenuListComponentOld from "@/components/profile/MenuListComponentOld";
import ModalCustomForm from "@/components/profile/modal/ModalCustomForm";
import ModalConfirm from "@/components/alert-modal/ModalConfirm";
import OtherLoading from "@/components/other/OtherLoading";
import Mission from "@/components/profile/Mission";
import UpcomingReward from "@/components/profile/UpComingReward";
import MemberCard from "@/components/profile/MemberCard.vue";
import CardConnectChannel from "@/components/profile/CardConnectChannel.vue";
import ModalLoading from "@/components/other/ModalLoading.vue";
export default {
  components: {
    ProfileComponent,
    ModalCustomForm,
    ModalConfirm,
    OtherLoading,
    MenuListComponentOld,
    BannerProfilePanel,
    Mission,
    UpcomingReward,
    MemberCard,
    CardConnectChannel,
    ModalLoading,
    MarketPlaceBanner
  },
  mounted() {},
  data() {
    return {
      MenuList: [],
      profile: { ...this.$store.state.shortProfile },
      lineProfile: this.$config.isLoginLine
        ? this.$cookies.isKey("user_profile_token")
          ? this.$cookies.get("user_profile_token")
          : this.$store.state.userProvider
        : {},
      isLoading: true,
      filter: {
        SocialProvider: this.$config.socialProvider,
        SocialId: ""
      },
      privilegeList: [],
      notFoundData: false,
      rewardList: [],
      filterNews: {
        page: 1,
        take: 10
      },
      newsList: [],
      bannerList: [],
      FGFList: [],
      filterBanner: {
        level_id: 1
      },
      marketPlaceObject: [],
      bannerFriend: [],
      customFormList: [],
      bannerIndex: 0,
      memberLevel: {},
      customLink: []
    };
  },

  async mounted() {
    this.getProfileDetail();
  },
  methods: {
    async getBannerGetFriend() {
      const res = await this.$axios(`/api/v1/FriendGetFriend/get`);
      this.bannerFriend = res.detail;
    },

    async getBanner() {
      await this.$axios
        .get(`/api/v1/banner/campaign_form`)
        .then(async data => {
          if (data.result == 1) {
            if (data.detail.totalCount > 0) {
              this.bannerList = data.detail.detail;
            }
          }
        })
        .catch(error => {
          console.log("getBanner", error.message);
        });
    },

    async unpairfunc() {
      try {
        this.$refs.modalLoading.show();
        const data = await this.$store.dispatch("unpairUser");
        console.log(data);
        if (data.result == 1) {
          this.$refs.modalLoading.hide();
          this.$router.push("/validatetelephone");
        } else window.alert("Internal Server Error.");
      } catch (error) {
        setTimeout(() => {
          this.$refs.modalLoading.hide();
          this.$router.push("/validatetelephone");
        }, 500);
      }
    },
    logout() {
      this.$refs.ModalConfirm.show();
    },
    async getProfileDetail() {
      this.memberTierDetail(this.profile.member_level_id);
      this.getBanner();
      this.getMenuList();
      this.getBannerGetFriend();
      this.getMarketPlace();
      this.getCustomLink();
      // const promise = async () =>
      //   Promise.all(() => [
      //     Promise.resolve(this.memberTierDetail(this.profile.member_level_id)),
      //     Promise.resolve(this.getBanner()),
      //     Promise.resolve(this.getMenuList()),
      //     Promise.resolve(this.getBannerGetFriend()),
      //     Promise.resolve(this.getMarketPlace())
      //   ]);
      // await promise();
      this.isLoading = false;
    },

    async getMarketPlace() {
      try {
        const data = await this.$axios(`/api/v1/User/get/marketplace`);

        this.marketPlaceObject = data.detail;
      } catch (error) {
        console.log("getMarketPlace", error.message);
      }
    },
    async getMenuList() {
      try {
        const data = await this.$axios(
          `/api/v1/setting/display_language/customer_menu`
        );
        this.MenuList = data.detail.filter(el => el.display == 1);
      } catch (error) {
        console.log("getMenu", error.message);
      }
    },

    async memberTierDetail(id) {
      this.memberLevel = this.$store.state.shortProfile.member_list.find(
        el => el.is_default == 1
      );
      this.memberLevel.upgrade_tier_name =
        this.memberLevel.upgrade_tier_id == 0
          ? ""
          : this.$store.state.shortProfile.member_list.find(
              a => a.id == this.memberLevel.upgrade_tier_id
            ).member_level_language[0].display;
    },
    async getCustomLink() {
      const res = await this.$axios("/api/v1/setting/customlink/list");
      this.customLink = res.detail.filter(el => el.status == 1);
    },
    openLink(url) {
      function isValidHttpUrl(string) {
        let url;
        try {
          url = new URL(string);
        } catch (_) {
          return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
      }
      console.log(url);
      let check = isValidHttpUrl(url);

      return !check ? window.open("https://" + url) : window.open(url);
    },
    getLinkDetail(items) {
      let langid = this.$cookies.get("lang").lang;
      return items.details.find(el => el.language_id == langid);
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-container {
  position: relative;
  background: white;
  margin: 1rem;
  border-radius: 5px;
}

.menulist-container {
  background: white;
  border-radius: 5px;
  margin: 1rem; // padding-bottom: 100px;
}

.line-text-pf {
  border-left: 6px solid black;
}

.btn-unpair {
  background-color: transparent;
  border: none;
  color: #bebebe;
}

.w-90 {
  width: 90%;
}

.banner-friend {
  img {
    border-radius: 5px;
    aspect-ratio: 16/9;
  }
}
// .brand-strip {
//   border-radius: 8px;
//   padding: 14px 8px;
//   background: linear-gradient(90deg, #3b0a16 0%, #6d0d20 45%, #f0a31a 100%);
// }
.brand-item {
  padding: 0 10px;
}
.new-custom-link-image {
  /* background: red; */
  // border-radius: 50%;
  /* padding: 1rem; */
  width: 54px;
  height: 100%;
  overflow: hidden;
}
.v-btn.v-btn--variant-plain.brand-btn {
  opacity: 1;
}
</style>
